import { fetchLfpGame, fetchLfpGameWinners } from '../../../entities/lfpGame';

export const scope = 'LFP_GAME_INFO_WIDGET';

export function fetchLfpGameIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.infoWidget;

        if (!widget.info.isFetching)
            dispatch(fetchLfpGame(payload, scope));
    };
}

export function fetchLfpGameWinnersIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.infoWidget;

        if (!widget.info.isFetching)
            dispatch(fetchLfpGameWinners(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/lfpGame/infoWidget.js